import { useEffect, useState } from "react";
import { RefreshCw, X } from "lucide-react";
import { onUpdateAvailable, applyUpdate, dismissUpdate } from "@/lib/swUpdate";

const GOLD = "#C9A84C";

/** Floats bottom-right, never auto-dismisses, never blocks the UI. */
export default function UpdateToast() {
  const [update, setUpdate] = useState(null);
  const [busy, setBusy] = useState(false);
  const [lift, setLift] = useState(16);

  useEffect(() => onUpdateAvailable(setUpdate), []);

  // Sit above the cookie banner while it is on screen so neither one is covered.
  useEffect(() => {
    if (!update) return;
    const measure = () => {
      const banner = document.querySelector('[data-testid="cookie-consent-banner"]');
      setLift(banner ? banner.getBoundingClientRect().height + 16 : 16);
    };
    measure();
    const t = setInterval(measure, 1000);
    window.addEventListener("resize", measure);
    return () => {
      clearInterval(t);
      window.removeEventListener("resize", measure);
    };
  }, [update]);

  if (!update) return null;

  return (
    <div
      className="fixed right-4 z-[100] w-[calc(100vw-2rem)] sm:w-[352px] animate-in slide-in-from-bottom-4 fade-in duration-300"
      style={{ bottom: lift }}
      role="status"
      aria-live="polite"
      data-testid="update-toast"
    >
      <div
        className="flex items-start gap-3 p-4"
        style={{
          background: "#112240",
          borderRadius: "8px",
          border: "1px solid rgba(201,168,76,0.28)",
          boxShadow: "0 12px 32px rgba(0,0,0,0.42)",
        }}
      >
        <div className="flex-1 min-w-0">
          <p className="text-[13.5px] leading-snug text-white" data-testid="update-toast-message">
            A new version of Plan-Sarthi is available.
          </p>
          <button
            type="button"
            onClick={async () => {
              setBusy(true);
              await applyUpdate();
            }}
            disabled={busy}
            className="mt-3 inline-flex items-center gap-1.5 h-8 px-3 rounded-md text-[12.5px] font-semibold transition-transform duration-150 active:scale-[0.98] disabled:opacity-70"
            style={{ background: GOLD, color: "#0A1628" }}
            data-testid="update-toast-reload-btn"
          >
            <RefreshCw className={`w-3.5 h-3.5 ${busy ? "animate-spin" : ""}`} />
            {busy ? "Updating…" : "Reload to update"}
          </button>
        </div>
        <button
          type="button"
          onClick={() => dismissUpdate(update.version)}
          aria-label="Dismiss"
          className="p-1 -m-1 shrink-0 transition-colors duration-150 hover:text-white"
          style={{ color: "#8B96A5" }}
          data-testid="update-toast-dismiss-btn"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
